import { setPageLoading } from '@falla/utils/src/page-util';

import styles from './index.module.less';

export default (props) => {
  setPageLoading(false);

  return <div className={styles.container}>{props.children}</div>;
};
